import React, { useState } from 'react';
import { Dialog, DialogActions, DialogContent, MenuItem, TextField, Switch, FormControlLabel, IconButton, Chip, Tooltip } from '@mui/material';
import { ArrowCircleRight, Edit } from '@mui/icons-material';
import { useAppData } from '../../../../../../../context/AppDataContext';





const LeadStatusBadge = ({ value, callBack,caption=true }) => {
    const [dialogStatus, setDialogStatus] = useState(false);
    const [inputStatus, setInputStatus] = useState(value);
    const [remark, setRemark] = useState("");

    const {masters,getMasterLabel} = useAppData();


    const handleUpdate = () => {
        if (callBack) {
            callBack({
                status: inputStatus,
                remark: remark
            });
        }
        setDialogStatus(false);
        setRemark(""); // Reset remark for next use
    };

    const chipProps = {
        label: getMasterLabel('lead-status', value),
        sx: { 
            fontWeight: 'bold',
            border: 'none',
            '& .MuiChip-label': { px: 2 }
        }
    };

    // Add interactive props only if callBack is provided
    if (callBack) {
        chipProps.onClick = () => setDialogStatus(true);
        chipProps.onDelete = () => setDialogStatus(true);
        chipProps.deleteIcon = <Edit style={{ color: 'inherit', fontSize: '14px' }} />;
    }

    return (
        <>
            {/* Visual Chip to display current status */}
            {caption ?
                <Chip {...chipProps} />
                :
                <Tooltip title="Update Status">
                    <IconButton onClick={()=>setDialogStatus(true)} style={{padding:"0px"}}>
                        <ArrowCircleRight />
                    </IconButton>
                </Tooltip>
            }
            {callBack && 
            <Dialog
                open={dialogStatus}
                onClose={() => setDialogStatus(false)}
                fullWidth={true}
                maxWidth="xs"
            >
                <div className='p-3 fw-bold border-bottom'>Update Lead Status</div>
                <DialogContent>
                    <div className='row mt-2'>
                        <div className='col-md-12'>
                            {/* Status Selection */}
                            <TextField
                                select
                                fullWidth
                                label="Select Status"
                                value={inputStatus}
                                onChange={(e) => setInputStatus(e.target.value)}
                                margin="normal"
                            >
                                {masters['lead-status'].map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </TextField>

                            {/* Remark Textarea */}
                            <TextField
                                fullWidth
                                multiline
                                rows={3}
                                label="Remark/Reason for change"
                                value={remark}
                                onChange={(e) => setRemark(e.target.value)}
                                margin="normal"
                                placeholder="Why is this status changing?"
                            />

                            
                        </div>
                    </div>
                </DialogContent>
                <DialogActions className="p-3">
                    <button className='btn btn-light' onClick={() => setDialogStatus(false)}>Cancel</button>
                    <button className='btn btn-primary' onClick={handleUpdate}>Update Status</button>
                </DialogActions>
            </Dialog>
            }
        </>
    );
};

export default LeadStatusBadge;